/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Commit_Message_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Explain what change you made to this project." |
*
* @param {Team_Sync_Commit_Message_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_commit_message_placeholder = /** @type {((inputs?: Team_Sync_Commit_Message_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Commit_Message_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Expliquez les changements que vous avez apportés à ce projet.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erläutern Sie, welche Änderung Sie an diesem Projekt vorgenommen haben.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spiega quali modifiche hai apportato a questo progetto.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Объясните, какие изменения вы внесли в этот проект.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Explique qué cambio realizó en este proyecto.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请解释你对这个项目做了哪些改动。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このプロジェクトにどのような変更を加えたかを説明してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आपने इस प्रोजेक्ट में क्या बदलाव किए, इसका वर्णन करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Explique qual alteração você fez neste projeto.")
	return /** @type {LocalizedString} */ ("Explain what change you made to this project.")
});